import React from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export function CompetitorInfoLine({ value }) {
    return (
        <ListGroup.Item>
            <Container>
                <Row>
                    <Col xs={4}>{value.membershipNo}</Col>
                    <Col>{value.firstName} {value.lastName}</Col>
                    {value.age != null && <Col xs={2} className="text-end">{value.age}</Col>}
                    <Col xs={1} className="text-end">{value.position}</Col>
                </Row>
            </Container>
        </ListGroup.Item>
    );
}